import { live } from '../../clients/proto';

export const DefaultTerminalInfo = new live.TerminalInfo({
  deviceId: 789,
  nid: 1203,
});

const USER_TOKEN_KEY = 'smart_translate_token';

export function saveToken(token: string) {
  localStorage.setItem(USER_TOKEN_KEY, token);
}

export function clearToken() {
  localStorage.removeItem(USER_TOKEN_KEY);
}

export function loadToken(): string {
  const tokenStr = localStorage.getItem(USER_TOKEN_KEY);
  return tokenStr || '';
}
